import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import './Sitemap.css';

const Sitemap = () => {
  return (
    <>
      <SEOHead 
        title="Sitemap - YT DOWN | Navigate Our Video Downloader Website"
        description="Browse YT DOWN sitemap. Find all pages including YouTube downloader, TikTok downloader, support, legal pages, and more. Easy navigation for our free video downloader service."
        keywords="sitemap, site navigation, yt down pages, youtube downloader sitemap, tiktok downloader pages, website map"
        url="https://digimac.pro/sitemap"
      />
      <section id="sitemap" className="sitemap-section">
      <div className="sitemap-container">
        <div className="sitemap-hero">
          <h1 className="sitemap-title">Sitemap</h1>
          <p className="sitemap-subtitle">Navigate Our YouTube & TikTok Video Downloader Website</p>
        </div>

        <div className="sitemap-content">
          <div className="sitemap-grid">
            
            {/* Main Pages */}
            <div className="sitemap-category">
              <h2 className="category-title">Main Pages</h2>
              <ul className="sitemap-links">
                <li><Link to="/">Home - Free Video Downloader</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/faq">FAQ - Frequently Asked Questions</Link></li>
                <li><Link to="/how-to-use">How to Use Our Downloader</Link></li>
                <li><Link to="/features">Features & Benefits</Link></li>
              </ul>
            </div>

            {/* Download Tools */}
            <div className="sitemap-category">
              <h2 className="category-title">Download Tools</h2>
              <ul className="sitemap-links">
                <li><Link to="/?platform=youtube">YouTube Video Downloader</Link></li>
                <li><Link to="/?platform=tiktok">TikTok Video Downloader</Link></li>
                <li><Link to="/">HD Video Downloader</Link></li>
                <li><Link to="/">MP4 Video Downloader</Link></li>
                <li><Link to="/">No Watermark Downloader</Link></li>
              </ul>
            </div>

            {/* Blog & Resources */}
            <div className="sitemap-category">
              <h2 className="category-title">Blog & Resources</h2>
              <ul className="sitemap-links">
                <li><Link to="/blog">Blog Home</Link></li>
                <li><Link to="/blog/how-to-download-youtube-videos">How to Download YouTube Videos</Link></li>
                <li><Link to="/blog/how-to-download-tiktok-videos-without-watermark">Download TikTok Without Watermark</Link></li>
                <li><Link to="/blog/best-video-downloader-tools-2024">Best Video Downloader Tools 2024</Link></li>
                <li><Link to="/blog/youtube-video-formats-explained">YouTube Video Formats Explained</Link></li>
                <li><Link to="/blog/tiktok-copyright-guide">TikTok Copyright Guide</Link></li>
                <li><Link to="/blog/download-youtube-mp3-audio">Download YouTube MP3 Audio</Link></li>
                <li><Link to="/blog/safe-video-downloading-tips">Safe Video Downloading Tips</Link></li>
              </ul>
            </div>

            {/* Legal Pages */}
            <div className="sitemap-category">
              <h2 className="category-title">Legal & Policies</h2>
              <ul className="sitemap-links">
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms & Conditions</Link></li>
                <li><Link to="/disclaimer">Disclaimer</Link></li>
                <li><Link to="/sitemap">Sitemap</Link></li>
              </ul>
            </div>

            {/* Popular Searches */}
            <div className="sitemap-category">
              <h2 className="category-title">Popular Searches</h2>
              <ul className="sitemap-links">
                <li><Link to="/">YouTube to MP4</Link></li>
                <li><Link to="/">YouTube to MP3</Link></li>
                <li><Link to="/">TikTok Video Download</Link></li>
                <li><Link to="/">Download YouTube Shorts</Link></li>
                <li><Link to="/">Free Video Downloader Online</Link></li>
                <li><Link to="/">HD Video Download</Link></li>
                <li><Link to="/">4K Video Downloader</Link></li>
              </ul>
            </div>

            {/* Support */}
            <div className="sitemap-category">
              <h2 className="category-title">Support & Help</h2>
              <ul className="sitemap-links">
                <li><Link to="/contact">Get Support</Link></li>
                <li><Link to="/faq">Common Questions</Link></li>
                <li><Link to="/how-to-use">User Guide</Link></li>
                <li><Link to="/about">About Our Service</Link></li>
              </ul>
            </div>

          </div>

          <div className="sitemap-footer">
            <h3>Need Help Finding Something?</h3>
            <p>Can't find what you're looking for? Visit our <Link to="/contact">Contact Page</Link> or check our <Link to="/faq">FAQ Section</Link>.</p>
            <Link to="/" className="back-home-btn">Back to Home</Link>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Sitemap;
